module.exports = __webpack_public_path__ + "static/media/Card_Temperature_en.77b50dea.svg";